import { render } from "./TravelPass.vue?vue&type=template&id=f7223f48&lang=pug"
import script from "./TravelPass.vue?vue&type=script&lang=ts"
export * from "./TravelPass.vue?vue&type=script&lang=ts"

import "./TravelPass.vue?vue&type=style&index=0&id=f7223f48&lang=scss"
script.render = render

export default script